module.exports = __webpack_public_path__ + "static/media/delete.b5f6a142.svg";